import { toDisplayString as _toDisplayString, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/low_battery.png'
import _imports_1 from '@/assets/images/update.png'


const _hoisted_1 = { class: "pantry-detail-title-view" }
const _hoisted_2 = { class: "pantry-detail-title-view-image-area" }
const _hoisted_3 = { class: "pantry-detail-title-view-circle-text-view" }
const _hoisted_4 = { class: "pantry-detail-title-view-circle-text" }
const _hoisted_5 = { class: "pantry-detail-title-view-name-area" }
const _hoisted_6 = { class: "pantry-detail-title-view-stock-display-area" }
const _hoisted_7 = { class: "pantry-detail-title-view-stock-list-area" }
const _hoisted_8 = { class: "pantry-detail-title-view-stock-area" }
const _hoisted_9 = { class: "pantry-detail-title-view-stock-text" }
const _hoisted_10 = { class: "pantry-detail-title-view-low-battery" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-detail-title-view-low-battery-icon",
  src: _imports_0
}, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "pantry-detail-title-view-stock-text"
}
const _hoisted_13 = {
  key: 1,
  class: "pantry-detail-title-view-plate-name-empty"
}
const _hoisted_14 = {
  key: 0,
  class: "pantry-detail-title-view-plate-update-area"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "pantry-detail-title-view-update-image" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "pantry-detail-title-view-update-image-icon",
    src: _imports_1
  })
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "pantry-detail-title-view-update-text" }, "残量更新", -1)
const _hoisted_17 = { class: "pantry-detail-title-view-name-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "pantry-detail-title-view-circle-graph",
        style: { 'background-image': _ctx.styleBackgroundImage }
      }, [
        (!_ctx.isShowImage())
          ? (_openBlock(), _createBlock("div", _mergeProps({ key: 0 }, _ctx.loadError, { class: "pantry-detail-title-view-circle" }), [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, _toDisplayString(_ctx.getName()), 1)
              ])
            ], 16))
          : (_openBlock(), _createBlock("img", _mergeProps({ key: 1 }, _ctx.loadError, {
              class: "pantry-detail-title-view-image",
              src: _ctx.imageUrl,
              onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
            }), null, 16, ["src"]))
      ], 4)
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, _toDisplayString(_ctx.stock), 1),
            _withDirectives(_createVNode("div", _hoisted_10, [
              _hoisted_11
            ], 512), [
              [_vShow, _ctx.showLowBattery]
            ])
          ]),
          (_ctx.plateName != null)
            ? (_openBlock(), _createBlock("div", _hoisted_12, _toDisplayString(_ctx.plateName), 1))
            : (_openBlock(), _createBlock("div", _hoisted_13))
        ]),
        (_ctx.isShowPlateUpdate())
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              _createVNode("div", {
                class: "pantry-detail-title-view-plate-update-view",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickUpdatePlate(...args))),
                style: { 'background': _ctx.styleUpdateButtonBackground }
              }, [
                _hoisted_15,
                _hoisted_16
              ], 4)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_17, _toDisplayString(_ctx.name), 1)
    ])
  ]))
}